import { render, staticRenderFns } from "./klerk.vue?vue&type=template&id=fba0c8a8&scoped=true&"
import script from "./klerk.vue?vue&type=script&lang=js&"
export * from "./klerk.vue?vue&type=script&lang=js&"
import style0 from "./klerk.vue?vue&type=style&index=0&id=fba0c8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0c8a8",
  null
  
)

export default component.exports